var levelOfAWSUsage = {
	"Level of AWS usage": "Уровень использования AWS",
	"Do not use AWS today": "Не пользуюсь AWS на сегодняшний день",
	"Evaluating/experimenting with AWS": "Оцениваю продукты AWS, экспериментирую с ними",
	"Run dev/test workloads on AWS": "Выполняю в AWS рабочие нагрузки разработки и тестирования",
	"Run a production workload on AWS": "Выполняю в AWS одну рабочую нагрузку",
	"Run multiple production workloads on AWS": "Выполняю в AWS множество рабочих нагрузок"
};

export { levelOfAWSUsage as default };
